import React, { useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import IosShareIcon from '@mui/icons-material/IosShare';
import { LineShareButton, LineIcon, TwitterShareButton, TwitterIcon } from "react-share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useRecoilState } from 'recoil';
import { partyNameState } from '../../../store/partyNameState';
import { trackEvent } from "../../../utils/gtag";

// 共有元ごとにUTMパラメータを付与したURLを組み立てる（GA4のチャネル/キャンペーンレポートで
// バイラル経由の流入・コンバージョンを識別できるようにするため）
export const buildShareUrl = (source: string, medium: string): string => {
  const shareUrl = new URL(window.location.href);
  shareUrl.searchParams.set('utm_source', source);
  shareUrl.searchParams.set('utm_medium', medium);
  shareUrl.searchParams.set('utm_campaign', 'party_share');
  return shareUrl.toString();
};

export const CopyUrlButton = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [partyName] = useRecoilState(partyNameState);
  // 共有元ごとにUTM付きURLを組み立てる
  const lineUrl = buildShareUrl('line', 'social');
  const twitterUrl = buildShareUrl('twitter', 'social');
  const copyUrl = buildShareUrl('copy_url', 'share');
  const shareText = `${partyName ? partyName + 'の' : ''}席順が決まりました！`;

  // モーダルを開く
  const handleOpen = () => setOpen(true);
  // モーダルを閉じる
  const handleClose = () => {
    setOpen(false);
    // モーダルを閉じるとコピー状態をリセット
    setCopied(false);
  };
  // URLをコピーする
  const handleCopy = () => {
    navigator.clipboard.writeText(copyUrl);
    setCopied(true);
    // GA4: 共有クリックイベント送信（URLコピー）
    trackEvent('share_click', { method: 'copy_url' });
  };

  return (
    <>
      <Button 
        variant="contained"
        className={classes.button}
        TouchRippleProps={{ center: true }} 
        onClick={handleOpen}
        startIcon={<IosShareIcon />}
        style={{ margin: '10px', fontSize: "11px"}}
      >
        共有
      </Button>

      {/* 共有用モーダル */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>リンクを共有</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {/* LINE 共有ボタン */}
          <LineShareButton
            url={lineUrl}
            className={classes.fullWidth}
            onClick={() => trackEvent('share_click', { method: 'line' })}
          >
            <Button
              variant="contained"
              className={classes.lineButton}
              startIcon={<LineIcon size={24} round />}
              fullWidth
            >
              LINEで共有
            </Button>
          </LineShareButton>
          {/* X(Twitter) 共有ボタン */}
          <TwitterShareButton
            url={twitterUrl}
            title={shareText}
            className={classes.fullWidth}
            onClick={() => trackEvent('share_click', { method: 'twitter' })}
          >
            <Button
              variant="contained"
              className={classes.twitterButton}
              startIcon={<TwitterIcon size={24} round />}
              fullWidth
            >
              Xで共有
            </Button>
          </TwitterShareButton>
          {/* URL コピー ボタン */}
          <Button 
            variant="contained" 
            className={classes.copyButton}
            onClick={handleCopy}
            startIcon={<ContentCopyIcon />}
            fullWidth
          >
            {copied ? "コピーしました" : "URLをコピー"}
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "#1976d2",
    color: theme.palette.common.white,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    padding: "20px",
  },
  fullWidth: {
    width: "100%",
  },
  lineButton: {
    backgroundColor: "#06C755",
    color: theme.palette.common.white,
  },
  twitterButton: {
    backgroundColor: "#000000",
    color: theme.palette.common.white,
  },
  copyButton: {
    backgroundColor: "#1976d2",
    color: theme.palette.common.white,
  },
}));